module.exports = __webpack_public_path__ + "img/old4.926a7d57.jpg";